export default __webpack_public_path__ + "static/media/home-slide_5.03e4022b.jpg";